import api from '@/shared/api/api-client';

import type { Session } from '../domain/session.model';
import type { SecuritySessionsGateway } from './security-sessions.gateway';

/** Real implementation over the shared api client; the auth session endpoints. */
export const httpSecuritySessionsGateway: SecuritySessionsGateway = {
  listSessions: () => api.get<Session[]>('/auth/sessions'),
  revokeSession: async (id: string) => {
    await api.delete(`/auth/sessions/${id}`);
  },
};
